export default __webpack_public_path__ + "static/media/Set3_Board1.82a828d1.png";